import { render } from "./Reference.vue?vue&type=template&id=6e38c247&scoped=true&ts=true"
import script from "./Reference.vue?vue&type=script&lang=ts"
export * from "./Reference.vue?vue&type=script&lang=ts"

import "./Reference.vue?vue&type=style&index=0&id=6e38c247&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e38c247"]])

export default __exports__